import React, { useState } from "react";
import { getVehicles } from "../services/vehicleInvoiceService";
import VehicleTable from "../components/VehicleTable";
import VehicleDetails from "../components/VehicleDetails";
import "../styles/dashboard.css";

function Dashboard() {
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  return (
    <div className="container-fluid mt-3">

      <div className="d-flex dashboard-container">

        {/* LEFT - 1/5 */}
        <div className="dashboard-left">
          <VehicleTable
            vehicles={getVehicles.vehicles}
            onSelect={setSelectedVehicle}
          />
        </div>

        {/* RIGHT - 4/5 */}
        <div className="dashboard-right">
          <VehicleDetails vehicle={selectedVehicle} />
        </div>

      </div>
    </div>
  );
}


export default Dashboard;